import React from "react";

import PropTypes from "prop-types";

import ScopedSearch from "~components/organisms/search/search_instant_dropdown/search_instant_dropdown";
import StickySideNavWrapper from "~components/utils/sticky_side_nav_wrapper/sticky_side_nav_wrapper";

import { LINK } from "../../../prop_types";
import RscHbNavExpandingMenu from "./components/rsc_hub_nav_expanding_menu/rsc_hb_nav_expanding_menu";
import { sideNavWrapperStyle } from "./rsc_hb_side_nav.module.scss";

function RscHbSideNav({
  items,
  level1ActiveItem,
  level2ActiveItem,
  searchIndices,
  navigationConfig,
}) {
  const { searchResourcesTitle } = navigationConfig;

  return (
    <StickySideNavWrapper>
      <div className={sideNavWrapperStyle}>
        <ScopedSearch
          indices={searchIndices}
          searchResourcesTitle={searchResourcesTitle}
        />
        <RscHbNavExpandingMenu
          items={items}
          level1ActiveItem={level1ActiveItem}
          level2ActiveItem={level2ActiveItem}
        />
      </div>
    </StickySideNavWrapper>
  );
}

RscHbSideNav.defaultProps = {
  items: [],
  level1ActiveItem: "",
  level2ActiveItem: "",
  searchIndices: [],
};

RscHbSideNav.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({ title: PropTypes.string, link: LINK })
  ),
  level1ActiveItem: PropTypes.string,
  level2ActiveItem: PropTypes.string,
  searchIndices: PropTypes.arrayOf(PropTypes.shape({})),
  navigationConfig: PropTypes.shape({
    searchResourcesTitle: PropTypes.string,
  }).isRequired,
};

export default RscHbSideNav;
